module.exports = function (listener) {
    var readyRep = /complete|loaded|interactive/;

    if (readyRep.test(document.readyState) && document.body) {
        listener();
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            listener();
        }, false);
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/util/ready.js
// module id = 5
// module chunks = 0 2 4